import { PageHero } from "@/components/PageHero";
import { Books, NewspaperClipping, BookOpen, Clock } from "@phosphor-icons/react";

const SHELVES = [
  { count: "2,400+", label: "Fiction", icon: BookOpen },
  { count: "1,800+", label: "Non-fiction", icon: Books },
  { count: "900+", label: "Children", icon: BookOpen },
  { count: "30+", label: "Magazines & Papers", icon: NewspaperClipping },
];

const Library = () => (
  <div data-testid="library-page">
    <PageHero
      overline="Aristotle Library"
      title={
        <>
          Five thousand books.
          <br />
          <span className="italic text-brand-gold">One quiet lounge.</span>
        </>
      }
      lead="A reading sanctuary tucked inside the clubhouse — books for every age, newspapers, magazines and a soft armchair always within reach."
      image="https://images.unsplash.com/photo-1507842217343-583bb7270b66?auto=format&fit=crop&w=1600&q=80"
    />

    <section className="py-24 md:py-32 px-6 md:px-10">
      <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-5">
        {SHELVES.map((s, i) => {
          const Icon = s.icon;
          return (
            <div
              key={s.label}
              data-testid={`library-stat-${i}`}
              className="p-8 rounded-2xl bg-brand-sage/40 border border-brand-sage"
            >
              <Icon size={28} weight="light" className="text-brand-forest" />
              <div className="font-display text-4xl text-brand-forest mt-6">{s.count}</div>
              <div className="text-sm text-brand-mute mt-1">{s.label}</div>
            </div>
          );
        })}
      </div>

      <div className="max-w-5xl mx-auto mt-20 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        <div>
          <h2 className="font-display text-4xl md:text-5xl text-brand-forest">
            How borrowing works
          </h2>
          <ul className="mt-8 space-y-4 text-brand-mute leading-relaxed">
            <li>
              <strong className="text-brand-forest">Membership:</strong> Free for all Exente residents.
              Sign up at the clubhouse desk.
            </li>
            <li>
              <strong className="text-brand-forest">Borrow:</strong> Up to 3 books for 21 days. Renew once, in person.
            </li>
            <li>
              <strong className="text-brand-forest">Late returns:</strong> ₹5 / day per book — proceeds fund new acquisitions.
            </li>
            <li className="flex items-start gap-2">
              <Clock size={20} weight="light" className="text-brand-gold mt-1" />
              <span>Open daily, 9:00 AM — 9:00 PM.</span>
            </li>
          </ul>
        </div>
        <div className="rounded-2xl overflow-hidden">
          <img
            src="https://images.unsplash.com/photo-1481627834876-b7833e8f5570?auto=format&fit=crop&w=1200&q=80"
            alt="Library interior"
            className="w-full h-[480px] object-cover"
          />
        </div>
      </div>
    </section>
  </div>
);

export default Library;
